import _ from 'lodash';
import NamedError from 'goodeggs-named-error';
import * as sites from 'goodeggs-sites';

export default __filename;
angular.module(__filename, []).factory(
  'Producer',
  ngInject(($http, settings) => ({
    getProducers: _.memoize(() =>
      $http({
        method: 'POST',
        url: `${sites.getUrl('catalog-api', settings)}/graph`,
        data: {
          operationName: 'getProducers',
          query: `\
query getProducers {
  producers {
    id
    name
    slug
  }
}\
`,
        },
      }).then((result) => {
        const graphQLResponse = result.data;
        if (
          graphQLResponse == null ||
          graphQLResponse.data == null ||
          graphQLResponse.data.producers == null ||
          graphQLResponse.data.producers.length < 1
        ) {
          throw new NamedError({
            message: 'Unexpected response from Catalog API for getProducers query',
            data: {result},
          });
        }
        if (graphQLResponse.errors != null) {
          throw new NamedError({
            message: 'Error response from Catalog API for getProducers query',
            data: {result},
          });
        }

        return graphQLResponse.data.producers;
      }),
    ),
  })),
);
